var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoyAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.366,
    height: 29.366,
    viewBox: "0 0 29.366 29.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M14.683,0A14.683,14.683,0,1,0,29.366,14.683,14.683,14.683,0,0,0,14.683,0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_491",
    "data-name": "Rectangle 491",
    width: 3.274,
    height: 3.306,
    transform: "translate(12.951 18.062)",
    fill: "#e9e7de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M41.639,81.582H31.722a1.789,1.789,0,0,0-1.789,1.789v6.643H43.428V83.371a1.789,1.789,0,0,0-1.789-1.789",
    transform: "translate(-22.093 -60.214)",
    fill: "#e9e7de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M72.431,49.675a1.339,1.339,0,1,1-1.339-1.339,1.339,1.339,0,0,1,1.339,1.339",
    transform: "translate(-51.483 -35.676)",
    fill: "#fed2bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M34.09,49.675a1.339,1.339,0,1,1-1.339-1.339,1.339,1.339,0,0,1,1.339,1.339",
    transform: "translate(-23.184 -35.676)",
    fill: "#fed2bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M73.4,51.168a.8.8,0,1,1-.8-.8.8.8,0,0,1,.8.8",
    transform: "translate(-52.996 -37.176)",
    fill: "#ff8f78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M35.059,51.168a.8.8,0,1,1-.8-.8.8.8,0,0,1,.8.8",
    transform: "translate(-24.697 -37.176)",
    fill: "#ff8f78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M46.552,25.122a5.015,5.015,0,0,0-10.014,0h-.015v5.295h0c0,.007,0,.013,0,.02a5.021,5.021,0,0,0,10.043,0c0-.007,0-.013,0-.02h0V25.122Z",
    transform: "translate(-26.958 -15.052)",
    fill: "#fed2bc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_492",
    "data-name": "Rectangle 492",
    width: 8.829,
    height: 8.432,
    transform: "translate(10.184 21.368)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M51.08,66.833A1.637,1.637,0,0,0,52.717,65.2H49.443a1.637,1.637,0,0,0,1.637,1.637",
    transform: "translate(-36.493 -48.12)",
    fill: "#aa3727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M51.327,76.49l-2.4,1.173-2.4-1.173v2.95l2.4-1.173,2.4,1.173Z",
    transform: "translate(-34.336 -56.456)",
    fill: "#c62717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M54.544,89.907a.633.633,0,1,1-.633-.633.633.633,0,0,1,.633.633",
    transform: "translate(-39.323 -65.891)",
    fill: "#e9e7de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M54.544,99.907a.633.633,0,1,1-.633-.633.633.633,0,0,1,.633.633",
    transform: "translate(-39.323 -73.272)",
    fill: "#e9e7de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M41.373,18.157H39.989v-.005H36.5a3.158,3.158,0,0,0-3.511,3.293v4.82h.9c.279,0,.431-.223.431-.517V24.661h0c0-.086.005-.168.009-.251.089-1.893,1.174-2.965,2.377-2.965H39.7v0H41.16c1.2,0,2.285,1.07,2.376,2.96,0,.085.009.168.009.256h0v1.088c0,.293.152.517.431.517h.9V21.45a3.158,3.158,0,0,0-3.512-3.293",
    transform: "translate(-24.351 -13.398)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M47.718,30.178c1.953,0,3.222,2.7,6.666,2.7v-2.89H47.718Z",
    transform: "translate(-35.22 -22.13)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M45.663,49.2a.607.607,0,1,1-.607-.607.607.607,0,0,1,.607.607",
    transform: "translate(-32.807 -35.868)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M63.517,49.2a.607.607,0,1,1-.607-.607.607.607,0,0,1,.607.607",
    transform: "translate(-45.985 -35.868)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M58.356,46.871a2.223,2.223,0,1,1,2.223-2.223,2.225,2.225,0,0,1-2.223,2.223m0-3.927a1.7,1.7,0,1,0,1.7,1.7,1.706,1.706,0,0,0-1.7-1.7",
    transform: "translate(-41.43 -31.314)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M40.5,46.871a2.223,2.223,0,1,1,2.223-2.223A2.225,2.225,0,0,1,40.5,46.871m0-3.927a1.7,1.7,0,1,0,1.7,1.7,1.706,1.706,0,0,0-1.7-1.7",
    transform: "translate(-28.253 -31.314)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M54.266,49.9h-.754a.259.259,0,1,1,0-.518h.754a.259.259,0,1,1,0,.518",
    transform: "translate(-39.305 -36.446)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M45.192,46.111a.167.167,0,0,1-.127-.059.612.612,0,0,0-.427-.153.765.765,0,0,0-.54.161.167.167,0,0,1-.239-.235,1.069,1.069,0,0,1,.79-.261.915.915,0,0,1,.67.27.167.167,0,0,1-.127.276",
    transform: "translate(-32.336 -33.63)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M61.832,46.112a.167.167,0,0,1-.127-.276.916.916,0,0,1,.67-.27,1.079,1.079,0,0,1,.79.261.167.167,0,1,1-.239.235.768.768,0,0,0-.54-.161.613.613,0,0,0-.427.153.166.166,0,0,1-.127.059",
    transform: "translate(-45.513 -33.631)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M53.413,59.451a.924.924,0,0,1-.8-.469.8.8,0,0,0,1.6,0,.924.924,0,0,1-.8.469",
    transform: "translate(-38.831 -43.533)",
    fill: "#ff8f78"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoyAvatar);
export default __webpack_public_path__ + "static/media/boy-avatar.a51b62aaf32bce54a0dd51fad3be6976.svg";
export { ForwardRef as ReactComponent };